import { WALL_TYPE } from '~/vendor/cx-sdk/constants';
import { z } from 'zod';

export const wallTypeSchema = z.enum(
  Object.values(WALL_TYPE) as [keyof typeof WALL_TYPE, ...(keyof typeof WALL_TYPE)[]],
);
export type WallType = z.infer<typeof wallTypeSchema>;
